<style>
@import '../../custom/css/ver-pedidos-contratos.css';
</style>

<template>
  <div class="ver-pedidos-contratos">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">Pedidos de plano</h1>
      <hr class="linha-amarela" />
    </div>
    <div class="contratos">
      <div class="row m-0">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12 p-0"
          v-for="contrato in contratosProfissionais"
        >
          <div class="card-contrato">
            <div class="cc-header row m-0">
              <div class="col-6 p-0">Cód: {{ contrato.id }}</div>
              <div class="col-6 p-0">Data: {{ contrato.atualizado_em }}</div>
              <div class="col-12 p-0">
                Status:
                <div class="d-inline-block" v-if="contrato.destaque === 0">
                  Pendente
                </div>
                <div class="d-inline-block" v-else>Aceito</div>
              </div>
              <div class="col-12 p-0">Email: {{ contrato.usuario.email }}</div>
            </div>
            <div class="cc-footer">
              <div class="btn-aceitar-pedido" @click="verPedido(contrato.id)">
                Ver Pedido
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ver-pedidos-contratos',
  created() {
    this.$store.dispatch('showContratosProfissional', this.id);
  },
  computed: {
    ...mapGetters(['getNotification', 'getTipoNotification']),
    ...mapState({
      contratosProfissionais: (state) => state.contratosProfissionais,
    }),
  },
  methods: {
    verPedido(value) {
      this.$router.push({
        name: 'administrador-ver-pedido-contrato',
        params: { id: value },
      });
    },
  },
};
</script>
